.downloadColumn_Billing_63bd459{width:60%;text-align:end}.redHighlight_Billing_63bd459{color:var(--primary-color-1);font-weight:bold}